import styles from './PostComposerWorkflow.module.css'

export default function PublishStep({ publishTo, settings, destination, regulationTarget, regulationCopy, showStepLabel = true }) {
  return (
    <section className={styles.step} aria-labelledby="post-composer-distribution-heading">
      <header className={styles.stepHeader}>
        {/* One-page mode has no steps to count, and its jump bar already names
            this section, so the step eyebrow would only mislead. */}
        {showStepLabel ? <p className={styles.stepEyebrow}>Step 3 of 3</p> : null}
        {/* id must match changeStep's `post-composer-${step}-heading` focus
            target, and the step's canonical value is `distribution`. */}
        <h2 id="post-composer-distribution-heading" tabIndex={-1}>Publish</h2>
      </header>
      {publishTo}
      {regulationTarget}
      {regulationCopy}
      {settings}
      {destination}
    </section>
  )
}
